import React from "react"

import Layout from "../components/layout"
import Seo from "../components/seo"

import Map from "../components/Map/Map"
import useMapData from "../hooks/useMapData"

const MapPage = ({ location }) => {
	return (
		<Layout>
      <Seo title="Map of Origins: Chinese Clans in Singapore" />
      <Map location={location} data={useMapData()} />
    </Layout>
  )
}

export default MapPage
